// Project 100K: fresh-stock countdown. Works out the state in South African time (UTC+2, no daylight saving)
// and keeps counting live. Liquid supplies the dates; this file supplies the wording.
(() => {
  if (customElements.get('p100k-stock-countdown')) return;

  const SAST = '+02:00';
  const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const at = (ymd, hm = '00:00') => new Date(`${ymd}T${hm}:00${SAST}`);
  const plural = (n, w) => `${n} ${w}${n === 1 ? '' : 's'}`;
  const dayLabel = (ymd) => {
    const d = at(ymd);
    const sast = new Date(d.getTime() + 2 * 3600e3); // read the weekday/day in SAST
    return `${DAYS[sast.getUTCDay()]} ${sast.getUTCDate()} ${MONTHS[sast.getUTCMonth()]}`;
  };
  // Whole SAST calendar days from today to the date.
  const daysUntil = (ymd, now) => {
    const today = new Date(now.getTime() + 2 * 3600e3).toISOString().slice(0, 10);
    return Math.round((at(ymd).getTime() - at(today).getTime()) / 86400e3);
  };
  const left = (ms) => {
    const m = Math.max(1, Math.ceil(ms / 60e3));
    const d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
    if (d >= 1) return h ? `${plural(d, 'day')} ${plural(h, 'hour')}` : plural(d, 'day');
    if (h >= 1) return mm ? `${plural(h, 'hour')} ${plural(mm, 'minute')}` : plural(h, 'hour');
    return plural(mm, 'minute');
  };

  class StockCountdown extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('.p100k-sc__text');
      this.render();
      this.timer = setInterval(() => this.render(), 30e3);
    }
    disconnectedCallback() { clearInterval(this.timer); }

    // Pre-packs are in stock: ship today if ordered on a weekday before the cutoff, else the next weekday.
    renderPrepack() {
      const [ch, cm] = (this.dataset.cutoffTime || '12:00').split(':').map(Number);
      const now = new Date();
      const s = new Date(now.getTime() + 2 * 3600e3); // SAST clock via UTC getters
      const dow = s.getUTCDay();
      const minutes = s.getUTCHours() * 60 + s.getUTCMinutes();
      const cut = (ch || 0) * 60 + (cm || 0);
      let html, urgent = false;
      if (dow >= 1 && dow <= 5 && minutes < cut) {
        const ms = (cut - minutes) * 60e3 - s.getUTCSeconds() * 1e3;
        urgent = ms < 2 * 3600e3;
        html = `<strong>In stock.</strong> Order in the next <strong>${left(ms)}</strong> and it ships <strong>today</strong>.`;
      } else {
        const friendly = (dow === 5 || dow === 6 || dow === 0) ? 'on Monday' : 'tomorrow';
        html = `<strong>In stock.</strong> Order now and it ships <strong>${friendly}</strong>.`;
      }
      this.classList.toggle('is-urgent', urgent);
      this.text.innerHTML = html;
      this.hidden = false;
    }

    render() {
      if (this.dataset.mode === 'prepack') return this.renderPrepack();
      const { week, run, next, cutoffDay, cutoffTime, reason } = this.dataset;
      if (!week || !run) { this.hidden = true; return; }
      const now = new Date();
      const cutoff = new Date(at(week).getTime() + (Number(cutoffDay) - 1) * 86400e3);
      const [ch, cm] = (cutoffTime || '12:00').split(':').map(Number);
      cutoff.setTime(cutoff.getTime() + ((ch || 0) * 60 + (cm || 0)) * 60e3);
      const days = daysUntil(run, now);
      const note = reason ? ` <span class="p100k-sc__note">Moved this week: ${reason.replace(/&/g, '&amp;').replace(/</g, '&lt;')}</span>` : '';
      let html, urgent = false;

      if (now >= cutoff) {
        const n = daysUntil(next, now);
        html = `<strong>This week's fresh stock is all packed.</strong> Order now and it's cut for <strong>${dayLabel(next)}</strong>${n > 0 ? ` (${plural(n, 'day')} away)` : ''}.`;
      } else if (days > 0) {
        html = days === 1
          ? `Fresh stock arrives <strong>tomorrow</strong>, fresh from the dry rooms.`
          : `Fresh stock arrives in <strong>${plural(days, 'day')}</strong>, fresh from the dry rooms.`;
      } else if (days === 0 && now < at(run, '12:00')) {
        html = `Fresh stock comes out of the dry rooms <strong>today</strong>.`;
      } else {
        const ms = cutoff - now;
        urgent = ms < 24 * 3600e3;
        html = `<strong>Fresh stock is out.</strong> Order in the next <strong>${left(ms)}</strong> to get this week's fresh stock.`;
      }
      this.classList.toggle('is-urgent', urgent);
      this.text.innerHTML = html + note;
      this.hidden = false;
    }
  }
  customElements.define('p100k-stock-countdown', StockCountdown);
})();
